import { c as _c } from "react/compiler-runtime";
import React from "react";
import { NumericFormat } from "react-number-format";
import { EffektCheckbox } from "../../../../shared/components/EffektCheckbox/EffektCheckbox";
import CharacterCountCircle from "../../../../shared/components/CharacterCountCircle/CharacterCountCircle";
import { SuggestedAmounts } from "../components/SuggestedAmounts";
import { FormData } from "../hooks/useFundraiserForm";
import { getThousandSeparator, getDecimalSeparator } from "../../../../../util/formatting";
import styles from "../FundraiserWidget.module.scss";
import { RadioButtonGroup } from "../../../../shared/components/RadioButton/RadioButtonGroup";
import { RecurringDonation } from "../../../../shared/components/Widget/types/Enums";
interface DonationDetailsPaneProps {
  formData: Pick<FormData, "amount" | "messageSenderName" | "message" | "showName" | "recurring">;
  onChange: (field: keyof FormData, value: any) => void;
  onSubmit: () => void;
  config: {
    suggested_amounts: number[];
    currency_symbol: string;
    donation_amount_label: string;
    name_label: string;
    message_label: string;
    show_name_label: string;
    next_button_text: string;
    monthly_donations?: {
      single_donation_text: string;
      monthly_donation_text: string;
    };
  };
  locale: string;
  className?: string;
  visible?: boolean;
}
export const DonationDetailsPane = React.forwardRef<HTMLDivElement, DonationDetailsPaneProps>((t0, ref) => {
  const $ = _c(74);
  const {
    formData,
    onChange,
    onSubmit,
    config,
    locale,
    className,
    visible
  } = t0;
  let t1;
  if ($[0] !== locale) {
    t1 = getThousandSeparator(locale);
    $[0] = locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const thousandSeparator = t1;
  let t2;
  if ($[2] !== locale) {
    t2 = getDecimalSeparator(locale);
    $[2] = locale;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const decimalSeparator = t2;
  const t3 = visible ? "block" : "none";
  let t4;
  if ($[4] !== t3) {
    t4 = {
      display: t3
    };
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onSubmit) {
    t5 = e => {
      e.preventDefault();
      onSubmit();
    };
    $[6] = onSubmit;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== config.monthly_donations || $[9] !== formData.recurring || $[10] !== onChange) {
    t6 = config.monthly_donations && <div className={styles["donation-widget__frequency-options"]}><RadioButtonGroup options={[{
        title: config.monthly_donations.single_donation_text,
        value: RecurringDonation.NON_RECURRING,
        data_cy: "fundraiser-single-donation-radio"
      }, {
        title: config.monthly_donations.monthly_donation_text,
        value: RecurringDonation.RECURRING,
        data_cy: "fundraiser-monthly-donation-radio"
      }]} selected={formData.recurring} onSelect={value => onChange("recurring", value)} /></div>;
    $[8] = config.monthly_donations;
    $[9] = formData.recurring;
    $[10] = onChange;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== config.currency_symbol || $[13] !== config.suggested_amounts || $[14] !== formData.amount || $[15] !== locale || $[16] !== onChange) {
    t7 = config.suggested_amounts.length > 0 && <div className={styles["donation-widget__input-group"]}><SuggestedAmounts amounts={config.suggested_amounts} selectedAmount={formData.amount} currencySymbol={config.currency_symbol} locale={locale} onSelect={amount => onChange("amount", amount)} /></div>;
    $[12] = config.currency_symbol;
    $[13] = config.suggested_amounts;
    $[14] = formData.amount;
    $[15] = locale;
    $[16] = onChange;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== onChange) {
    t8 = v => {
      onChange("amount", v.floatValue ?? null);
    };
    $[18] = onChange;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== config.donation_amount_label || $[21] !== decimalSeparator || $[22] !== formData.amount || $[23] !== t8 || $[24] !== thousandSeparator) {
    t9 = <NumericFormat id="amount" name="amount" value={formData.amount} data-cy="fundraiser-amount-input" onValueChange={t8} thousandSeparator={thousandSeparator} decimalSeparator={decimalSeparator} decimalScale={0} allowNegative={false} placeholder={config.donation_amount_label} required={true} min={1} step={1} />;
    $[20] = config.donation_amount_label;
    $[21] = decimalSeparator;
    $[22] = formData.amount;
    $[23] = t8;
    $[24] = thousandSeparator;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== config.currency_symbol) {
    t10 = <span className={styles["donation-widget__input-group__suffix"]}>{config.currency_symbol}</span>;
    $[26] = config.currency_symbol;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t9) {
    t11 = <div className={styles["donation-widget__input-group"]}>{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      marginTop: "2rem"
    };
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== onChange) {
    t13 = e_0 => onChange("messageSenderName", e_0.target.value);
    $[32] = onChange;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== config.name_label || $[35] !== formData.messageSenderName || $[36] !== formData.showName || $[37] !== t13) {
    t14 = <div className={styles["donation-widget__input-group"]} style={t12}><input id="messageSenderName" name="messageSenderName" type="text" value={formData.messageSenderName} onChange={t13} placeholder={config.name_label} required={formData.showName} maxLength={45} data-cy="fundraiser-name-input" /></div>;
    $[34] = config.name_label;
    $[35] = formData.messageSenderName;
    $[36] = formData.showName;
    $[37] = t13;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  let t15;
  if ($[39] !== onChange) {
    t15 = e_1 => onChange("message", e_1.target.value);
    $[39] = onChange;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== config.message_label || $[42] !== formData.message || $[43] !== t15) {
    t16 = <textarea id="message" name="message" value={formData.message} placeholder={config.message_label} onChange={t15} maxLength={250} data-cy="fundraiser-message-input" />;
    $[41] = config.message_label;
    $[42] = formData.message;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== formData.message.length) {
    t17 = formData.message.length > 0 && <CharacterCountCircle count={formData.message.length} max={250} />;
    $[45] = formData.message.length;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t17) {
    t18 = <div className={styles["donation-widget__message-sub"]}>{t17}</div>;
    $[47] = t17;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  let t19;
  if ($[49] !== t16 || $[50] !== t18) {
    t19 = <div className={styles["donation-widget__input-group"]}>{t16}{t18}</div>;
    $[49] = t16;
    $[50] = t18;
    $[51] = t19;
  } else {
    t19 = $[51];
  }
  let t20;
  if ($[52] !== onChange) {
    t20 = checked => {
      onChange("showName", checked);
    };
    $[52] = onChange;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== config.show_name_label || $[55] !== formData.showName || $[56] !== t20) {
    t21 = <div className={styles["donation-widget__checkbox-group"]}><EffektCheckbox checked={formData.showName} onChange={t20} dataCy="fundraiser-show-name">{config.show_name_label}</EffektCheckbox></div>;
    $[54] = config.show_name_label;
    $[55] = formData.showName;
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== config.next_button_text) {
    t22 = <button type="submit" className={styles["donation-widget__button"]} data-cy="fundraiser-donation-next">{config.next_button_text}</button>;
    $[58] = config.next_button_text;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== t11 || $[61] !== t14 || $[62] !== t19 || $[63] !== t21 || $[64] !== t22 || $[65] !== t5 || $[66] !== t6 || $[67] !== t7) {
    t23 = <form className={styles["donation-widget__form"]} data-cy="fundraiser-donation-form" onSubmit={t5}>{t6}{t7}{t11}{t14}{t19}{t21}{t22}</form>;
    $[60] = t11;
    $[61] = t14;
    $[62] = t19;
    $[63] = t21;
    $[64] = t22;
    $[65] = t5;
    $[66] = t6;
    $[67] = t7;
    $[68] = t23;
  } else {
    t23 = $[68];
  }
  let t24;
  if ($[69] !== className || $[70] !== ref || $[71] !== t23 || $[72] !== t4) {
    t24 = <div ref={ref} className={className} style={t4} data-cy="fundraiser-pane-donation">{t23}</div>;
    $[69] = className;
    $[70] = ref;
    $[71] = t23;
    $[72] = t4;
    $[73] = t24;
  } else {
    t24 = $[73];
  }
  return t24;
});
DonationDetailsPane.displayName = "DonationDetailsPane";